<div class="image-viewer">
    <img [src]="imageUrl" alt="Preview" />
</div>